import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../../../../consts";
import { t } from "../../../../../../services";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../../components";
import { audienceSetOptions } from "../../consts/audienceSetOptions";

export const AudienceSectionSummary = ({ audienceSectionData }) => {
  const { selectedDeviceModel, selectedDeviceType, audienceSetOption, selectedMarkets, versions } =
    audienceSectionData ?? {};

  return audienceSectionData ? (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      <Paragraph2>
        {selectedDeviceModel?.value} {t(selectedDeviceType?.value)}
      </Paragraph2>
      {audienceSetOption === audienceSetOptions.MARKET ? (
        <>
          {selectedMarkets && (
            <Paragraph2>
              {selectedMarkets
                .filter((m) => m.id)
                .map((m) => m.id)
                ?.join(", ")}
            </Paragraph2>
          )}
          {versions && <Paragraph2>{versions.map((v) => v.id)?.join(", ")}</Paragraph2>}
        </>
      ) : (
        <Paragraph2>{t(strCode.LIST_OF_DEVICES_INFO)}</Paragraph2>
      )}
    </WrapperContainer>
  ) : null;
};

AudienceSectionSummary.propTypes = {
  audienceSectionData: PropTypes.shape({
    selectedDeviceModel: PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    selectedDeviceType: PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }),
    audienceSetOption: PropTypes.string.isRequired,
    selectedMarkets: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
    ),
    versions: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string.isRequired, value: PropTypes.string.isRequired })
    )
  })
};
